import React, { forwardRef } from "react";

import classNames from "classnames";

import { StyledDotsLoader } from "./Styles";

export const DotsLoader = forwardRef<
  HTMLSpanElement,
  React.ComponentPropsWithoutRef<"span">
>(({ className, ...rest }, ref) => {
  return (
    <StyledDotsLoader
      ref={ref}
      className={classNames("c-loader c-loader--dots", className)}
      {...rest}
    >
      <span />
      <span />
      <span />
    </StyledDotsLoader>
  );
});

DotsLoader.displayName = "DotsLoader";
